<template>
    <JobCategorySearchContent
            :comId="comId"
            :perPage="perPage"
    >
        <template v-slot:select>
            <div style="width: 45%;height: 100%; position: absolute;left: 1px;">
                <div :style="{position: 'relative', top: topValue}">
                    <v-select
                        v-model="comId"
                        :items="productsList"
                        label="选择产品"
                        hide-details
                        single-line
                        @change="selectProduct"
                    />
                </div>
            </div>
        </template>
    </JobCategorySearchContent>
</template>

<script>
    import JobCategorySearchContent from "../../components/Order/JobCategorySearchContent";
    export default {
        components: {
            JobCategorySearchContent
        },
        data(){
            return {
                comId: 0,
                perPage: 15,
                productsList: [
                    { text: "和顺保A", value: "2016" },
                    { text: "和顺保B", value: "2017" },
                ],
                topValue: "12px",
                screenWidth: document.body.clientWidth,
            }
        },
        created() {
            this.comId = this.$route.params.comId
        },
        mounted() {
            if (document.body.clientWidth < 900){
                this.topValue = "4px"
            }
            window.onresize = () => {
                return (() => {
                    this.screenWidth = document.body.clientWidth
                })()
            }
        },
        watch:{
            screenWidth(val){
                if (val > 900){
                    this.topValue = "12px"
                }else{
                    this.topValue = "4px"
                }
            }
        },
        methods:{
            selectProduct(){
                const url = `/outer/category/search/${this.comId}`
                this.$router.push(url);
            }
        }
    }
</script>

<style scoped>

</style>
